import { STORAGE_KEYS } from '../core/storage-keys';
import type { ClientOrder } from '../stores/orders-store';

export class OrderPersistence {
  private static instance: OrderPersistence | null = null;

  static getInstance(): OrderPersistence {
    if (!OrderPersistence.instance) {
      OrderPersistence.instance = new OrderPersistence();
    }
    return OrderPersistence.instance;
  }

  getOrders(): ClientOrder[] {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEYS.orders);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  setOrders(orders: ClientOrder[]): void {
    window.localStorage.setItem(STORAGE_KEYS.orders, JSON.stringify(orders));
  }

  clearOrders(): void {
    window.localStorage.removeItem(STORAGE_KEYS.orders);
  }
}